import styled from 'styled-components';

export const ReferenceOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormHeaderContainer = styled.div`
  display: flex;
  padding: 24px 24px 22px;
  position: relative;
  align-items: center;
  justify-content: space-between;
`;

export const FormTitle = styled.h1`
  display: flex;
  min-width: 0;
  margin: 0;
  align-items: center;
  font-size: 16px;
  font-style: inherit;
  font-weight: 500;
  letter-spacing: -0.008em;
  line-height: 1;
`;
